var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("notifications", { attrs: { group: "foo" } }),
      _c(
        "div",
        {
          staticClass: "w-100",
          class: [_vm.theme === 1 ? "total-page-bg" : "total-page-bg-2"]
        },
        [
          _vm.isGioielleriaItalianaB2B
            ? _c("div", [
                _c(
                  "h4",
                  {
                    staticClass: "pt-4 color-configure mb-0 text-uppercase",
                    class: "color-configure-" + _vm.theme
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("configureJewel")) + " ")]
                )
              ])
            : _vm._e(),
          _c(
            "div",
            { staticClass: "swiper-container justify-content-center px-0" },
            [
              _vm.isGioielleriaItalianaB2B
                ? _c("BuildYourJewelHome")
                : _vm._e(),
              _c("list-item", { attrs: { section: "JEWELLERY" } }),
              _vm.isGioielleriaItalianaB2B
                ? _c("list-item", { attrs: { section: "ACCESSORIES" } })
                : _vm._e()
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }